// extracted by mini-css-extract-plugin
export default {"myModal":"modal_myModal__OKl4T","myModalContent":"modal_myModalContent__e3Cs6","active":"modal_active__74+QQ","closeButton":"modal_closeButton__N5bdJ"};